<h3 class="_white">{{'decisions.area.' + area | translate}}</h3>
<span class="areaPortrait-description">{{'decisions.area.' + area + '.portrait' | translate}}</span>

<kiwi-spacer [size]="40"></kiwi-spacer>

<kiwi-customer-distribution-parameters [customersDistribution]="areaPortrait.customersDistribution">
</kiwi-customer-distribution-parameters>

<kiwi-spacer [size]="40"></kiwi-spacer>

<kiwi-area-restaurants-repartition [areaPortrait]="areaPortrait"></kiwi-area-restaurants-repartition>

<kiwi-spacer [size]="24"></kiwi-spacer>

<button class="button areaButton" (click)="onSave()" [disabled]="areDecisionsReadonly">Choisir ce quartier</button>
